module.exports = __webpack_public_path__ + "img/rotationImgThree.d7b6d4d6.png";